import { render } from "./EconomicClassificationList.vue?vue&type=template&id=12f52ef2&scoped=true"
import script from "./EconomicClassificationList.vue?vue&type=script&lang=js"
export * from "./EconomicClassificationList.vue?vue&type=script&lang=js"

import "./EconomicClassificationList.vue?vue&type=style&index=0&id=12f52ef2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f52ef2"]])

export default __exports__